import { action, useStore, useStoreActions, useStoreState } from 'easy-peasy';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

const Logout = () => {
    
    const history = useHistory();
    const store = useStore();
    const toggleAuth = useStoreActions( store => store.toggleAuth)
    const eventDetails = useStoreState(state => state.eventDetails);
    const handleUserProfile = useStoreActions( store => store.handleUserProfile)
    const handleTempUser = useStoreActions( store => store.handleTempUser)
    const resetTempCart = useStoreActions(action => action.resetTempCart);
  const resetInstantCheckout = useStoreActions(action => action.resetInstantCheckout);
  let eventId =  eventDetails.id;

    const removeDataFromLocal = async () => {
        await store.persist.flush();
      };
      
    useEffect( () => {
      toggleAuth(false);
        removeDataFromLocal()
        localStorage.removeItem('[EasyPeasyStore][0][userProfile]');
        localStorage.removeItem('user-login-status');
        localStorage.removeItem('memzo-auth-token');
        handleUserProfile([]);
        handleTempUser([]);
        resetTempCart([])
        resetInstantCheckout([]);
        if(eventId)
        history.push(`${process.env.PUBLIC_URL}/event/`+eventId)
        else
        history.push(`${process.env.PUBLIC_URL}/login`)
    }, [])

    return null;
  
}

export default Logout